import React, { useEffect, useState } from "react";
import { db } from "../database/firebase";
import {
  collection,
  query,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
  getDoc,
  orderBy,
} from "firebase/firestore";
import Swal from "sweetalert2";

const ListaUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [busqueda, setBusqueda] = useState("");

  const handleDelete = async (id) => {
    try {
      const docRef = doc(db, "usuarios", id);
      Swal.fire({
        title: "¿Estas seguro?",
        text: "¡No podrás revertir esto!, en caso de querer crear una nueva cuenta con el mismo email debe borrar la anterior entrando en la sección Authentication de Firebase. Además, el usuario perderá los cursos que ha comprado.",
        icon: "warning",
        showCancelButton: true,
      })
        .then((result) => {
          if (result && result.isConfirmed) {
            return Swal.fire({
              title: "¿Estas totalmente seguro?",
              text: "El usuario desaparecerá de la lista pero perderá sus cursos comprados.",
              icon: "warning",
              showCancelButton: true,
            });
          }
        })
        .then(async (result) => {
          if (result && result.isConfirmed) {
            try {
              await deleteDoc(docRef);
              // Eliminar el usuario de la lista de usuarios
              const updatedUsuarios = usuarios.filter(
                (usuario) => usuario.id !== id
              );
              setUsuarios(updatedUsuarios);
              Swal.fire({
                title: "Usuario eliminado",
                text: "Recuerda que para crear una nueva cuenta con el mismo email debe borrar la anterior entrando en la sección Authentication de Firebase.",
                icon: "success",
                showCancelButton: true,
              });
            } catch (error) {
              console.log(error);
              Swal.fire({
                title: "Error al eliminar usuario",
                text: "Hubo un error al eliminar el usuario: " + error,
                icon: "error",
                showCancelButton: true,
              });
            }
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleClaseComprada = async (id, field) => {
    try {
      const userRef = doc(db, "usuarios", id);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const userData = userSnap.data();
        const updatedField = !userData[field]; // Cambia el valor opuesto
        await updateDoc(userRef, {
          [field]: updatedField,
        });

        // Actualiza el estado de los usuarios
        const updatedUsuarios = usuarios.map((usuario) => {
          if (usuario.id === id) {
            return { ...usuario, [field]: updatedField };
          }
          return usuario;
        });
        setUsuarios(updatedUsuarios);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchUsuarios = () => {
      const collectionRef = collection(db, "usuarios");
      const q = query(collectionRef, orderBy("fecha_creacion", "desc"));

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const usuarios = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));

        setUsuarios(usuarios);
      });

      // Limpiar el listener cuando el componente se desmonte
      return () => unsubscribe();
    };

    fetchUsuarios();
  }, []);

  const usuariosFiltrados = usuarios.filter((usuario) =>
    usuario.nombre.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div class="flex flex-col flex-grow w-full">
      {usuariosFiltrados.length === 0 && (
        <p class="text-white text-center font-bold text-[30px] leading-[48px]">
          Todavía no hay alumnos
        </p>
      )}
      <input
        class="bg-gray-700 border-1 border-white/20 text-white p-2 m-2 rounded shadow"
        type="text"
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        placeholder="Buscar por nombre"
      />
      <div class="max-h-[270px] overflow-y-auto scrollbar scrollbar-thumb-rounded-full scrollbar-thumb-[#4a8ded] scrollbar-track-[#444b5d] scrollbar-track-rounded">
        {usuariosFiltrados.map((usuario) => (
          <div
            class="border border-1 border-white/20 p-2 m-2 rounded shadow"
            key={usuario.id}
          >
            <div class="text-white flex items-center justify-between">
              <div class="flex items-center flex-grow">
                <button
                  class="bg-red-600 rounded hover:bg-red-800 text-white font-bold py-2 px-3 mr-2 shadow-btn-shadow shadow-red-600/25 transition-all duration-300"
                  onClick={() => handleDelete(usuario.id)}
                >
                  <svg
                    className="w-6 h-6 text-gray-800 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                    />
                  </svg>
                </button>
                <div class="flex flex-col mx-2">
                  <span class="font-bold border-b border-white my-1">
                    {usuario.nombre}
                  </span>
                  <span class="font-bold border-b border-white my-1">
                    {usuario.email}
                  </span>
                  <span class="font-bold border-b border-white my-1">
                    {usuario.telefono}
                  </span>
                </div>
              </div>
              <div class="text-white flex items-center max-w-[200px]">
                <button
                  class="bg-blue-600 rounded hover:bg-blue-800 text-white font-bold py-1 px-3 mr-2 ml-2 shadow-btn-shadow shadow-blue-600/25 transition-all duration-300 min-h-[56px] w-full"
                  onClick={() =>
                    handleClaseComprada(usuario.id, "clase_grabada")
                  }
                >
                  Clase Grabada: {usuario.clase_grabada ? "Si" : "No"}
                </button>
                <button
                  class="bg-green-500 rounded hover:bg-green-700 text-white font-bold py-1 px-3 mr-2 ml-2 shadow-btn-shadow shadow-green-600/25 transition-all duration-300 min-h-[56px] w-full"
                  onClick={() =>
                    handleClaseComprada(usuario.id, "clase_online")
                  }
                >
                  Clase Online: {usuario.clase_online ? "Si" : "No"}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListaUsuarios;
